import type { FabricObject } from 'fabric';

/**
 * Reads a custom property attached to a Fabric object (e.g. `autoFit`, `wrapText`)
 * and validates its shape before returning it as the typed config.
 */
export function readObjectConfig<T>(
  obj: FabricObject,
  key: string,
  validate: (cfg: Partial<T>) => boolean
): T | undefined {
  const candidate = (obj as unknown as Record<string, unknown>)[key];
  if (!candidate || typeof candidate !== 'object') return undefined;
  const cfg = candidate as Partial<T>;
  if (!validate(cfg)) return undefined;
  return cfg as T;
}
